// import ApplicationController from './application_controller'

// export default class extends ApplicationController {
//   static targets = ["opportunitySelect"]

//   connect() {
//     // Set initial donation amount (default to preset or 25)
//     console.log("hub logs controller connected")

//     this.updateDonationSummary()
//   }

//   async loadOpportunities(event) {
//     const organizationId = event.target.value

//     if (!organizationId) {
//       this.opportunitySelectTarget.innerHTML = '<option value="">Select Project/Fundraiser</option>'
//       return
//     }

//     try {
//       const response = await fetch(`/hub_organizations/${organizationId}/opportunities`)
//       if (!response.ok) throw new Error("Network response was not ok")
//       const data = await response.json()

//       this.opportunitySelectTarget.innerHTML = '<option value="">Select Project/Fundraiser</option>'
//       data.forEach(opportunity => {
//         const option = document.createElement("option")
//         option.value = opportunity.id
//         option.textContent = opportunity.name
//         this.opportunitySelectTarget.appendChild(option)
//       })
//     } catch (error) {
//       console.error("Error loading opportunities:", error)
//       this.opportunitySelectTarget.innerHTML = '<option value="">Failed to load opportunities</option>'
//     }
//   }
// }

import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["opportunitySelect"]

  connect() {
    console.log("hub logs controller connected")
  }

  async loadOpportunities(event) {
    console.log("loadOpportunities triggered")
    if (!this.hasOpportunitySelectTarget) {
      console.warn("opportunitySelect target is missing")
      return
    }

    const organizationId = event.target.value
    this.opportunitySelectTarget.innerHTML = '<option value="">Select Project/Fundraiser</option>'

    if (!organizationId) {
      console.log('no organization id')
      return
    }

    try {
      const response = await fetch(`/clubs/${organizationId}/related`)
      if (!response.ok) throw new Error("Network response was not ok")
      const data = await response.json()

      // Add optgroup for opportunities
      if (data.opportunities.length > 0) {
        const optGroup = document.createElement("optgroup")
        optGroup.label = "Opportunities"
        data.opportunities.forEach(item => {
          const option = document.createElement("option")
          option.value = item.id
          option.textContent = item.name
          optGroup.appendChild(option)
        })
        this.opportunitySelectTarget.appendChild(optGroup)
      }

      // Add optgroup for campaigns
      if (data.campaigns.length > 0) {
        const optGroup = document.createElement("optgroup")
        optGroup.label = "Campaigns"
        data.campaigns.forEach(item => {
          const option = document.createElement("option")
          option.value = item.id
          option.textContent = item.name
          optGroup.appendChild(option)
        })
        this.opportunitySelectTarget.appendChild(optGroup)
      }
    } catch (error) {
      console.error("Error loading opportunities:", error)
      this.opportunitySelectTarget.innerHTML = '<option value="">Failed to load options</option>'
    }
  }
}
